import { createContext, useContext, useEffect, useState, useMemo } from "react";
import React from "react";
import PropTypes from "prop-types";
import { useAuth } from "react-oidc-context";
import { useApi } from "./ApiClient";


export const ConsortiaCenterContext = createContext({
  consortiaCentres: []
  
});

export const ConsortiaCenterProvider = ({ children }) => {
    const [consortiaCentres, setConsortiaCentres] = useState([]);   
  const auth = useAuth();
  const api = useApi(process.env.REACT_APP_VAF_BASE_URL);



  useEffect(() => {
    const fetchConsortiaCentres = async () => {
      try {
        const response = await api.get(`getConsortiaCentreDetails`);
        const data = response.data.data;
        setConsortiaCentres(data);
      } catch (error) {
        console.log("Error fetching consortia centres:", error);
        
      }
    };
  if(auth.user) {
    fetchConsortiaCentres();
  }
  }, [auth.user]);
 

  

  const contextValue = useMemo(
    () => ({
      consortiaCentres,
    }),
    [
      consortiaCentres,
    ]
  );
  return (
    <ConsortiaCenterContext.Provider value={contextValue}>
      {children}
    </ConsortiaCenterContext.Provider>
  );
};

export const useConsortiaCenter = () => useContext(ConsortiaCenterContext);

ConsortiaCenterProvider.propTypes = {
 
};
